import React from "react";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import CTASection from "@/components/CTASection";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQ } from "@/data/site";

export default function Faq() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQ.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <>
      <Seo
        title="FAQ Recherche de Fuite d'Eau | Questions Fréquentes FuiteX"
        description="Combien coûte une recherche de fuite ? Est-ce remboursé par l'assurance ? Est-ce destructif ? Toutes les réponses à vos questions sur FuiteX."
        canonical="/faq"
        schema={schema}
      />
      <PageHero
        overline="FAQ"
        titleLines={["Questions fréquentes", "sur la recherche de fuite"]}
        subtitle="Prix, assurance, délais, méthode… Retrouvez les réponses aux questions que vous vous posez avant de nous contacter."
        breadcrumb={[{ label: "FAQ" }]}
      />

      <section className="bg-white py-24">
        <div className="container-x max-w-3xl">
          <Reveal>
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {FAQ.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-ink/10">
                  <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left text-lg font-bold text-ink hover:text-aqua hover:no-underline">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-base text-ink/70 leading-relaxed">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </section>

      <CTASection title="Une autre question ? Parlons de votre fuite." />
    </>
  );
}
